import { type FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { captureFeedbackScreenshot } from "../../Feedback/feedbackCapture.ts";
import { useClientSelector } from "../../Redux/clientHooks.ts";
import { userIdSelector } from "../../Redux/clientSlice.ts";
import { FeedbackComposer } from "./FeedbackComposer.tsx";
import { clearFeedbackDraft, readFeedbackDraft } from "./feedbackDraftStorage.ts";

export const GlobalFeedbackComposer: FC = () => {
	const userId = useClientSelector(userIdSelector);
	const navigate = useNavigate();
	const [open, setOpen] = useState(() => readFeedbackDraft()?.minimized === false);
	const [hasDraft, setHasDraft] = useState(() => readFeedbackDraft() !== null);
	const [screenshot, setScreenshot] = useState<string | null>(null);

	useEffect(() => {
		const openFromPage = () => {
			if (!userId) return;
			void (async () => {
				if (!hasDraft) setScreenshot(await captureFeedbackScreenshot());
				setOpen(true);
			})();
		};
		window.addEventListener("feedback-open-composer", openFromPage);
		return () => window.removeEventListener("feedback-open-composer", openFromPage);
	}, [hasDraft, userId]);

	if (!userId) return null;

	return (
		<FeedbackComposer
			open={open}
			screenshot={screenshot}
			onMinimize={() => setOpen(false)}
			onDiscard={() => {
				clearFeedbackDraft();
				setHasDraft(false);
				setScreenshot(null);
				setOpen(false);
			}}
			onDraftChange={setHasDraft}
			onCreated={() => {
				setScreenshot(null);
				setOpen(false);
				window.dispatchEvent(new Event("feedback-created"));
				void navigate("/feedback");
			}}
		/>
	);
};
